module.exports = __webpack_public_path__ + "img/process.1dd465fb.svg";